import { SearchResult } from '@/components/Document/WordReplacePanel/SearchResultItem';

/**
 * HTML 컨텐츠에서 검색어를 찾아서 검색 결과 목록 반환
 * @param htmlContent - HTML 문자열
 * @param searchText - 검색어
 * @returns 검색 결과 배열
 */
export const extractSearchResults = (
  htmlContent: string,
  searchText: string,
): SearchResult[] => {
  if (!searchText || searchText.trim() === '') {
    return [];
  }

  const results: SearchResult[] = [];
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');

  const lowerSearchText = searchText.toLowerCase();
  let matchIndex = 0;

  // highlightSearchTextInHTML과 동일한 방식으로 순회
  const processNode = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent || '';
      const lowerText = text.toLowerCase();

      if (!lowerText.includes(lowerSearchText)) return;

      // 하나의 텍스트 노드에 여러 매칭이 있을 수 있음
      let lastIndex = 0;
      let index = lowerText.indexOf(lowerSearchText, lastIndex);

      while (index !== -1) {
        // 검색어 앞뒤 35자 추출
        const snippetStart = Math.max(0, index - 35);
        const snippetEnd = Math.min(
          text.length,
          index + searchText.length + 35,
        );

        let snippet = text.slice(snippetStart, snippetEnd);

        // 앞쪽이 잘렸으면 ... 추가
        if (snippetStart > 0) {
          snippet = '...' + snippet;
        }

        // 뒤쪽이 잘렸으면 ... 추가
        if (snippetEnd < text.length) {
          snippet = snippet + '...';
        }

        results.push({
          id: `search-result-${matchIndex}`,
          snippet: snippet.trim(),
          fullText: text.trim(),
          searchWord: searchText,
        });

        matchIndex++;
        lastIndex = index + searchText.length;
        index = lowerText.indexOf(lowerSearchText, lastIndex);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const elem = node as Element;

      // mark 태그는 스킵
      if (elem.tagName === 'MARK') {
        return;
      }

      // highlightSearchTextInHTML과 동일하게 역순으로 처리
      const children = Array.from(node.childNodes);
      for (let i = children.length - 1; i >= 0; i--) {
        processNode(children[i]);
      }
    }
  };

  processNode(doc.body);

  // 역순으로 처리했으므로 결과도 역순 -> 다시 뒤집기
  return results.reverse();
};
